import { render, staticRenderFns } from "./_base-button-play.vue?vue&type=template&id=0563beb0&scoped=true"
import script from "./_base-button-play.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-button-play.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-button-play.vue?vue&type=style&index=0&id=0563beb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563beb0",
  null
  
)

export default component.exports